/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

import "../debugInfo.js"; // Vite 8: ensure debugInfo namespace is initialized first

gbc.constants.debugInfo.auiTreeNodeInfo = {
  Action: {
    collapsed: false,
    color: "#78DBE2"
  },
  ActionDefault: {
    collapsed: false,
    color: "#87A96B"
  },
  ActionDefaultList: {
    collapsed: true,
    color: "#FFA474"
  },
  Aggregate: {
    collapsed: false,
    color: "#FAE7B5"
  },
  Button: {
    collapsed: false,
    color: "#9F8170"
  },
  ButtonEdit: {
    collapsed: false,
    color: "#FD7C6E"
  },
  Canvas: {
    collapsed: false,
    color: "#ACE5EE"
  },
  CanvasArc: {
    collapsed: false,
    color: "#A2A2D0"
  },
  CanvasCircle: {
    collapsed: false
  },
  CanvasLine: {
    collapsed: false
  },
  CanvasOval: {
    collapsed: false
  },
  CanvasPolygon: {
    collapsed: false,
    color: "#DE5D83"
  },
  CanvasRectangle: {
    collapsed: false,
    color: "#B0B7C6"
  },
  CanvasText: {
    collapsed: false,
    color: "#B4674D"
  },
  CheckBox: {
    collapsed: false,
    color: "#FF7F49"
  },
  ComboBox: {
    collapsed: false,
    color: "#1F75FE"
  },
  Completer: {
    collapsed: false,
    color: "#1F75FE"
  },
  Config: {
    collapsed: false,
    color: "#EA7E5D"
  },
  DateEdit: {
    collapsed: false,
    color: "#CB4154"
  },
  DateTimeEdit: {
    collapsed: false,
    color: "#56004C"
  },
  DefaultActions: {
    collapsed: false,
    color: "#1CD3A2"
  },
  Dialog: {
    collapsed: false,
    color: "#1DACD6"
  },
  DialogEvent: {
    collapsed: false,
    color: "#BC5D58"
  },
  DialogInfo: {
    collapsed: false,
    color: "#DD9475"
  },
  DragDropInfo: {
    collapsed: false,
    color: "#9ACEEB"
  },
  Edit: {
    collapsed: false,
    color: "#FDDB6D"
  },
  FieldInfo: {
    collapsed: false,
    color: "#2B6CC4"
  },
  Folder: {
    collapsed: false,
    color: "#6E5160"
  },
  Form: {
    collapsed: false,
    color: "#CEFF1D"
  },
  FormField: {
    collapsed: false,
    color: "#71BC78"
  },
  FunctionCall: {
    collapsed: false,
    color: "#C364C5"
  },
  FunctionCallParameter: {
    collapsed: false,
    color: "#CC6666"
  },
  Grid: {
    collapsed: false,
    color: "#FCD975"
  },
  Group: {
    collapsed: false,
    color: "#A8E4A0"
  },
  GroupTitle: {
    collapsed: false,
    color: "#A8E4A0"
  },
  HBox: {
    collapsed: false,
    color: "#1164B4"
  },
  HLine: {
    collapsed: false,
    color: "#F0E891"
  },
  IdleAction: {
    collapsed: false,
    color: "#FF1DCE"
  },
  Image: {
    collapsed: false,
    color: "#CA3767"
  },
  ImageFonts: {
    collapsed: false,
    color: "#CA3767"
  },
  ImageFont: {
    collapsed: false,
    color: "#CA3767"
  },
  Item: {
    collapsed: false,
    color: "#3BB08F"
  },
  Label: {
    collapsed: false,
    color: "#DADA22"
  },
  Link: {
    collapsed: false,
    color: "#FFBD88"
  },
  Matrix: {
    collapsed: false,
    color: "#F664AF"
  },
  Menu: {
    collapsed: false,
    color: "#AAF0D1"
  },
  MenuAction: {
    collapsed: false,
    color: "#CD4A4C"
  },
  Message: {
    collapsed: false,
    color: "#EDD19C"
  },
  Page: {
    collapsed: false,
    color: "#FF8243"
  },
  PhantomColumn: {
    collapsed: false,
    color: "#C8385A"
  },
  PhantomEdit: {
    collapsed: false,
    color: "#EF98AA"
  },
  PhantomFormField: {
    collapsed: false,
    color: "#1A4876"
  },
  PhantomMatrix: {
    collapsed: false,
    color: "#30BA8F"
  },
  ProgressBar: {
    collapsed: false,
    color: "#C54B8C"
  },
  Property: {
    collapsed: false,
    color: "#1974D2"
  },
  PropertyArray: {
    collapsed: false,
    color: "#FFA343"
  },
  PropertyDict: {
    collapsed: false,
    color: "#BAB86C"
  },
  RadioGroup: {
    collapsed: false,
    color: "#FF7538"
  },
  RecordView: {
    collapsed: false,
    color: "#FF2B2B"
  },
  Rectangle: {
    collapsed: false,
    color: "#F8D568"
  },
  RowInfo: {
    collapsed: false,
    color: "#1CA9C9"
  },
  RowInfoList: {
    collapsed: false,
    color: "#FFCFAB"
  },
  Screen: {
    collapsed: false,
    color: "#FDDDE6"
  },
  ScrollArea: {
    collapsed: false,
    color: "#EFDECD"
  },
  ScrollGrid: {
    collapsed: false,
    color: "#A5694F"
  },
  Slider: {
    collapsed: false,
    color: "#8A795D"
  },
  SpacerItem: {
    collapsed: false,
    color: "#45CEA2"
  },
  SpinEdit: {
    collapsed: false,
    color: "#FB7EFD"
  },
  Stack: {
    collapsed: false,
    color: "#80DAEB"
  },
  StartMenu: {
    collapsed: false,
    color: "#80DAEB"
  },
  StartMenuCommand: {
    collapsed: false,
    color: "#ECEABE"
  },
  StartMenuGroup: {
    collapsed: false,
    color: "#FFCF48"
  },
  StartMenuSeparator: {
    collapsed: false,
    color: "#FD5E53"
  },
  Style: {
    collapsed: false,
    color: "#FAA76C"
  },
  StyleAttribute: {
    collapsed: false,
    color: "#18A7B5"
  },
  StyleList: {
    collapsed: true,
    color: "#EBC7DF"
  },
  Table: {
    collapsed: false,
    color: "#FC89AC"
  },
  TableAction: {
    collapsed: false,
    color: "#FC8900"
  },
  TableActions: {
    collapsed: false,
    color: "#FC00AC"
  },
  TableColumn: {
    collapsed: false,
    color: "#DBD7D2"
  },
  TextEdit: {
    collapsed: false,
    color: "#17806D"
  },
  TimeEdit: {
    collapsed: false,
    color: "#DEAA88"
  },
  ToolBar: {
    collapsed: false,
    color: "#77DDE7"
  },
  ToolBarItem: {
    collapsed: false,
    color: "#FFFF66"
  },
  ToolBarSeparator: {
    collapsed: false,
    color: "#926EAE"
  },
  TopMenu: {
    collapsed: false,
    color: "#324AB2"
  },
  TopMenuCommand: {
    collapsed: false,
    color: "#F75394"
  },
  TopMenuGroup: {
    collapsed: false,
    color: "#FFA089"
  },
  TopMenuSeparator: {
    collapsed: false,
    color: "#8F509D"
  },
  TreeInfo: {
    collapsed: false,
    color: "#A2ADD0"
  },
  TreeItem: {
    collapsed: false,
    color: "#FF43A4"
  },
  UserInterface: {
    collapsed: false,
    color: "#FC6C85"
  },
  VBox: {
    collapsed: false,
    color: "#CDA4DE"
  },
  Value: {
    collapsed: false,
    color: "#FCE883"
  },
  ValueList: {
    collapsed: true,
    color: "#C5E384"
  },
  WebComponent: {
    collapsed: false,
    color: "#FFAE42"
  },
  Window: {
    collapsed: false,
    color: "#CD9575"
  }
};
